export default (value, _options) => {
    return { success: true, value };
};
